module.exports = __webpack_public_path__ + "img/69.c561d684.jpg";